import Joi from "joi-browser";
import { shortDateYMD } from "../utils/DateHelper";

function nameErrorsAsString(errors) {
    let stringError = "";
    let err = errors[0];
    switch (err.type) {
        case "string.max":
            stringError = `can't exceed ${err.context.limit} letters.`;
            break;
        case "string.min":
            stringError = `can't be less than ${err.context.limit} letters.`;
            break;
        case "any.empty":
            stringError = "can't be an empty field.";
            break;
        case "string.regex.base":
            stringError = "should be an alphabetical characters only.";
            break;
        default:
            stringError = "is required.";
    }

    return {
        template: " {{message}}",
        context: {
            errors: errors.length,
            message: stringError,
        },
    };
}

function numberErrorsAsString(errors) {
    let stringError = "";
    let err = errors[0];
    switch (err.type) {
        case "number.min":
            stringError = `can't be less than ${err.context.limit}`;
            break;
        case "any.empty":
            stringError = "can't be an empty field.";
            break;
        case "string.regex.base":
            stringError = "should be a number.";
            break;
        case "number.max":
            stringError = `can not exceed ${err.context.limit}`;
            break;
        default:
            stringError = "is required.";
    }

    return {
        template: " {{message}}",
        context: {
            errors: errors.length,
            message: stringError,
        },
    };
}

function eolErrors(errors) {
    let stringError = "";
    let err = errors[0];
    switch (err.type) {
        case "date.min":
            stringError = "must be more than today";
            break;
        case "any.empty":
            stringError = "can't be an empty field.";
            break;
        case "date.max":
            stringError = "can't exceed 6 months";
            break;
        default:
            stringError = "is required.";
    }

    return {
        template: " {{message}}",
        context: {
            errors: errors.length,
            message: stringError,
        },
    };
}

const AddCouponSchemaStep1 = Joi.object().keys({
    name: Joi.string()
        .trim()
        .max(256)
        .min(3)
        .regex(/[\w[\]`!@#$%^&*()={}:;<>+'-]*/)
        .required()
        .label("Coupon Name")
        .error((errors) => {
            return nameErrorsAsString(errors);
        }),
    couponType: Joi.string()
        .required()
        .trim()
        .label("Coupon Type")
        .error((errors) => {
            return nameErrorsAsString(errors);
        }),
    percentage: Joi.number()
        .min(0.1)
        .max(100)
        .required()
        .label("Percentage")
        .error((errors) => {
            return numberErrorsAsString(errors);
        }),
    product: Joi.object()
        .required()
        .label("Product")
        .error(() => {
            return {
                template: " is required",
            };
        }),
    parameters: Joi.when(Joi.ref("$isParametersIncluded"), {
        is: false,
        then: Joi.optional(),
        otherwise: Joi.array().required().min(1),
    }),
});

const AddCouponSchemaStep2 = Joi.object().keys({
    expiresAt: Joi.when(Joi.ref("$isForever"), {
        is: true,
        then: Joi.optional(),
        otherwise: Joi.date()
            .min(new Date())
            .max(shortDateYMD(new Date(), 182))
            .required()
            .label("Expire Date")
            .error((errors) => {
                return eolErrors(errors);
            }),
    }),
    durationType: Joi.string()
        .required()
        .trim()
        .label("Coupon Recurring")
        .error((errors) => {
            return nameErrorsAsString(errors);
        }),
    quantity: Joi.number()
        .min(1)
        .max(10)
        .required()
        .label("Quantity")
        .error((errors) => {
            return numberErrorsAsString(errors);
        }),
});

const IncreaseStockSchema = Joi.object().keys({
    isForever: Joi.boolean().required(),
    quantity: Joi.number().min(1).max(10).required(),
    expiration: Joi.when(Joi.ref("$isForever"), {
        is: false,
        then: Joi.date()
            .required()
            .error((errors) => {
                return eolErrors(errors);
            }),
    }),
});

export default {
    AddCouponSchemaStep1,
    AddCouponSchemaStep2,
    IncreaseStockSchema,
};
